import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

export type LocationProps = {
  startLocation?: string | null
  endLocation?: string | null
  typeOfExperience?: string
  variant?: 'single' | 'start_and_end' | 'with_experience'
}

function TourV2Location(props: LocationProps) {
  const intl = useIntl()
  const { endLocation, startLocation, typeOfExperience, variant = 'single' } = props

  const startsEndsInLabel = intl.formatMessage(
    {
      id: 'fBeh124qft',
      defaultMessage: 'Starts in {startLocation}, Ends in {endLocation}',
      description: 'Tour location label showing distinct start and end locations',
    },
    { startLocation, endLocation },
  )
  const withExperienceLabel = typeOfExperience ? <FormattedMessage
    id="uL+e8/0cgt"
    defaultMessage="{startLocation}<experienceText> · {typeOfExperience}</experienceText>"
    description="Tour location label with styled experience type suffix"
    values={{
      startLocation,
      typeOfExperience,
      experienceText: (chunks) => <Caption as="span" variant="large" colour="neutral-two">{chunks}</Caption>,
    }}
  /> : startLocation

  return (
    <Group direction="horizontal" verticalAlign="center" gap={4}>
      {variant === 'single' && (
        <Caption variant="large" colour="neutral-one">
          {startLocation}
        </Caption>
      )}
      {variant === 'start_and_end' && (
        <Caption variant="large" colour="neutral-one">
          {startsEndsInLabel}
        </Caption>
      )}
      {variant === 'with_experience' && (
        <Caption variant="large" colour="neutral-one">
          {withExperienceLabel}
        </Caption>
      )}
    </Group>
  )
}
export default TourV2Location
